
import { defineComponent, reactive,ref, toRefs, computed} from 'vue'
import reportComfirmTitle from '../title.vue'

interface State {
    brandName: string;
    modelName: string;
    vin: string;
    engineNo: string;
    logo: string;
    basicItemInfos: object[];
}
export default defineComponent({
    name: 'reportConfirmCarInfo',
    components: {
        reportComfirmTitle
    },
    props: {
        renderData: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
})
